
import keys from 'lodash/keys';
import startsWith from 'lodash/startsWith';

import log from 'loglevel';

const originalFactory = log.methodFactory;

let _addPrefixName = false;

log.methodFactory = function (methodName, logLevel, loggerName) {
    var rawMethod = originalFactory(methodName, logLevel, loggerName);

    return function (message) {
        if (_addPrefixName) {
            rawMethod(`[${loggerName}] ${message}`);
        } else {
            rawMethod(message);
        }
    };
};

function getLevel(name) {
    let level;
    keys(log.getLoggers()).forEach(item => {
        if (startsWith(item, name)) {
            level = log.getLogger(item).getLevel();
        }
    });

    return level;
}

function getLogger(name) {
    return log.getLogger(name);
}

function getLoggerNames() {
    return keys(log.getLoggers());
}

function init(defaultLevel, options) {
    options = options || {};
    setLevel(defaultLevel);
    if (options.prefixName) {
        setPrefixName(options.prefixName);
    }
}

function setLevel(level, name) {
    name = name || '';
    let affectedLoggers = [];
    if (!name) {
        log.setDefaultLevel(level);
        log.setLevel(level, false);
        affectedLoggers.push('ROOT');
    }

    keys(log.getLoggers()).forEach(item => {
        if (startsWith(item, name)) {
            log.getLogger(item).setLevel(level, false);
            affectedLoggers.push(item);
        }
    });

    return affectedLoggers;
}

function setPrefixName(value) {
    _addPrefixName = value;
}

export default {
    getLevel,
    getLogger,
    getLoggerNames,
    init,
    setLevel,
    setPrefixName,

    levels: log.levels
};
